module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('b-checkbox', {
    model: {
      value: (_vm.showDetailIcon),
      callback: function($$v) {
        _vm.showDetailIcon = $$v
      },
      expression: "showDetailIcon"
    }
  }, [_vm._v("Detail column")])], 1), _vm._v(" "), _vm._l((_vm.columnsVisible), function(column, index) {
    return _c('div', {
      key: index,
      staticClass: "control"
    }, [_c('b-checkbox', {
      model: {
        value: (column.display),
        callback: function($$v) {
          _vm.$set(column, "display", $$v)
        },
        expression: "column.display"
      }
    }, [_vm._v("\n                    " + _vm._s(column.title) + "\n                ")])], 1)
  })], 2), _vm._v(" "), _c('b-table', {
    ref: "table",
    attrs: {
      "data": _vm.data,
      "detailed": "",
      "hoverable": "",
      "custom-detail-row": "",
      "opened-detailed": ['Board Games'],
      "default-sort": ['name', 'asc'],
      "detail-key": "name",
      "show-detail-icon": _vm.showDetailIcon
    },
    on: {
      "details-open": function (row, index) { return _vm.$buefy.toast.open(("Expanded " + (row.name))); }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "field": "name",
            "visible": _vm.columnsVisible['name'].display,
            "label": _vm.columnsVisible['name'].title,
            "width": "300",
            "sortable": ""
          }
        }, [(_vm.showDetailIcon) ? [_vm._v("\n                        " + _vm._s(props.row.name) + "\n                    ")] : [_c('a', {
          on: {
            "click": function($event) {
              _vm.toggle(props.row)
            }
          }
        }, [_vm._v("\n                            " + _vm._s(props.row.name) + "\n                        ")])]], 2), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "sold",
            "visible": _vm.columnsVisible['sold'].display,
            "label": _vm.columnsVisible['sold'].title,
            "sortable": "",
            "centered": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.sold) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "available",
            "visible": _vm.columnsVisible['available'].display,
            "label": _vm.columnsVisible['available'].title,
            "sortable": "",
            "centered": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.available) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "visible": _vm.columnsVisible['cleared'].display,
            "label": _vm.columnsVisible['cleared'].title,
            "centered": ""
          }
        }, [_c('span', {
          class: [
            'tag',
            {
              'is-danger': props.row.sold / props.row.available <= 0.45
            },
            {
              'is-success': props.row.sold / props.row.available > 0.45
            }
          ]
        }, [_vm._v("\n                        " + _vm._s(Math.round((props.row.sold / props.row.available) * 100)) + "%\n                    ")])])]
      }
    }, {
      key: "detail",
      fn: function(props) {
        return _vm._l((props.row.items), function(item) {
          return _c('tr', {
            key: item.name
          }, [(_vm.showDetailIcon) ? _c('td') : _vm._e(), _vm._v(" "), _c('td', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.columnsVisible['name'].display),
              expression: "columnsVisible['name'].display"
            }]
          }, [_vm._v("    " + _vm._s(item.name))]), _vm._v(" "), _c('td', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.columnsVisible['sold'].display),
              expression: "columnsVisible['sold'].display"
            }],
            staticClass: "has-text-centered"
          }, [_vm._v(_vm._s(item.sold))]), _vm._v(" "), _c('td', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.columnsVisible['available'].display),
              expression: "columnsVisible['available'].display"
            }],
            staticClass: "has-text-centered"
          }, [_vm._v(_vm._s(item.available))]), _vm._v(" "), _c('td', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.columnsVisible['cleared'].display),
              expression: "columnsVisible['cleared'].display"
            }],
            staticClass: "has-text-centered"
          }, [_c('span', {
            class: [
              'tag',
              {
                'is-danger': item.sold / item.available <= 0.45
              },
              {
                'is-success': item.sold / item.available > 0.45
              }
            ]
          }, [_vm._v("\n                            " + _vm._s(Math.round((item.sold / item.available) * 100)) + "%\n                        ")])])])
        })
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62735d73"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/table/examples/ExCustomDetailedRow.vue
// module id = 1213
// module chunks = 1 90